import { render, staticRenderFns } from "./editSld.vue?vue&type=template&id=1961b2ee&scoped=true"
import script from "./editSld.vue?vue&type=script&lang=js"
export * from "./editSld.vue?vue&type=script&lang=js"
import style0 from "./editSld.vue?vue&type=style&index=0&id=1961b2ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1961b2ee",
  null
  
)

export default component.exports